// const BASE_URL = import.meta.env.VITE_BASE_URL || "";
const IMAGE_BASE_URL = new URL('../assets/images/siteImg/', import.meta.url).href;

const VITE_IMAGE_BASE_URL = import.meta.env.VITE_IMAGE_BASE_URL;
const VITE_IMAGE_URL = `${VITE_IMAGE_BASE_URL}/siteImg/`;

const IMAGES = {
    bannerContactImg: new URL(`${IMAGE_BASE_URL}/contact/Banner_Contact_Desktop.png`, import.meta.url).href,
    bgIcon5: `${IMAGE_BASE_URL}/sec-4-bg-icon-2.svg`,
    bannerContactImg2: `${IMAGE_BASE_URL}/contact/Banner_Contact_Desktop.png`,
    chatImg: `${IMAGE_BASE_URL}contact/Image_Chat.png`,
    faqImg: `${IMAGE_BASE_URL}/checklistImg/Image_FAQ.png`,
    answersImg: `${IMAGE_BASE_URL}contact/Image_Answers.png`,
    Image_LCCommunity: `${VITE_IMAGE_URL}contact/Image_LCCommunity.png`,
    customerSupportIcon: `${VITE_IMAGE_URL}contact/Icon_CustomerSupport.svg`,
};
console.log(IMAGES, IMAGE_BASE_URL);
// console.log("VITE_IMAGE&Meta:", import.meta.env.VITE_IMAGE_BASE_URL);

export default IMAGES;
